import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Asegúrate que la ruta a tu config de firebase sea correcta
import { doc, updateDoc } from 'firebase/firestore';

const DonationWidgetConfigModal = ({ isOpen, onClose, userProfile }) => {
  const [ctaMessage, setCtaMessage] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('#1F2937');
  const [showAmount, setShowAmount] = useState(true);
  const [buttonText, setButtonText] = useState('Donar');

  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  // useEffect se ejecuta cuando el modal se abre o el perfil del usuario cambia
  useEffect(() => {
    if (userProfile?.donations?.widgetConfig) {
      const config = userProfile.donations.widgetConfig;
      setCtaMessage(config.ctaMessage || 'Si te gustó la historia, ¡apoya al autor!');
      setBackgroundColor(config.backgroundColor || '#1F2937');
      setShowAmount(config.showAmount !== false); // Si es undefined, lo dejamos en true
      setButtonText(config.buttonText || 'Donar');
    }
  }, [userProfile, isOpen]);

  // Función para guardar los cambios en Firestore
  const handleSave = async () => {
    if (ctaMessage.length > 60) {
      setError('El mensaje no puede tener más de 60 caracteres.');
      return;
    }
    if (buttonText.length > 10) {
        setError('El texto del botón no puede tener más de 10 caracteres.');
        return;
    }
    setIsSaving(true);
    setError('');

    try {
      const userDocRef = doc(db, 'users', userProfile.uid);
      
      // Creamos el objeto con la nueva configuración
      const newWidgetConfig = {
        ctaMessage,
        backgroundColor,
        showAmount,
        buttonText: buttonText || 'Donar',
      };

      // Actualizamos únicamente el campo 'widgetConfig' dentro de 'donations'
      await updateDoc(userDocRef, {
        'donations.widgetConfig': newWidgetConfig,
      });

      onClose(); // Cierra el modal al tener éxito
    } catch (err) {
      console.error("Error al guardar la configuración del widget:", err);
      setError("No se pudieron guardar los cambios. Inténtalo de nuevo.");
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[120]">
      <div className="bg-gray-800 rounded-lg shadow-xl w-full max-w-lg p-6 text-white relative">
        <h2 className="text-2xl font-bold mb-4">Configurar Widget de Donaciones</h2>
        <div className="space-y-6">
          {/* Input para el Mensaje */}
          <div>
            <label className="block text-sm font-medium text-gray-300">Mensaje de donación (CTA)</label>
            <input 
              type="text" 
              value={ctaMessage}
              onChange={(e) => setCtaMessage(e.target.value)}
              maxLength="60"
              className="mt-1 w-full px-4 py-2 text-white bg-gray-700 border border-gray-600 rounded-md"
            />
            <p className="text-xs text-right text-gray-400 mt-1">{ctaMessage.length}/60</p>
          </div>

          {/* Selector de Color */}
          <div>
            <label className="block text-sm font-medium text-gray-300">Color de fondo del bloque</label>
            <div className="flex items-center mt-1">
              <input 
                type="color" 
                value={backgroundColor}
                onChange={(e) => setBackgroundColor(e.target.value)}
                className="w-10 h-10 p-1 bg-gray-700 border border-gray-600 rounded-md cursor-pointer"
              />
              <span className="ml-3 px-3 py-1 bg-gray-700 rounded-md text-sm">{backgroundColor}</span>
            </div>
          </div>

          {/* BOTON DONAR*/}
          <div>
            <label className="block text-sm font-medium text-gray-300">Texto del botón de donar</label>
            <input 
              type="text" 
              value={buttonText}
              onChange={(e) => setButtonText(e.target.value)}
              maxLength="20"
              className="mt-1 w-full px-4 py-2 text-white bg-gray-700 border border-gray-600 rounded-md"
            />
            <p className="text-xs text-right text-gray-400 mt-1">{buttonText.length}/20</p>
          </div>

          {/* Checkbox para mostrar cantidad */}
          <div className="flex items-center">
            <input 
              type="checkbox" 
              checked={showAmount}
              onChange={(e) => setShowAmount(e.target.checked)}
              id="showAmountCheck"
              className="h-5 w-5 rounded text-indigo-500 bg-gray-700 border-gray-600 focus:ring-indigo-600"
            />
            <label htmlFor="showAmountCheck" className="ml-3 text-sm text-gray-300">
              Mostrar la cantidad donada en las "burbujas" de donación.
            </label>
          </div>
        </div>

        <p className="text-xs text-gray-500 mt-6 italic">
          Estos cambios se aplicarán en todos los capítulos donde las donaciones estén activadas.
        </p>

        {error && <p className="text-red-500 text-sm mt-4 text-center">{error}</p>}

        <div className="flex justify-end space-x-4 pt-6 mt-4 border-t border-gray-700">
          <button onClick={onClose} disabled={isSaving} className="px-6 py-2 font-bold text-gray-300 bg-gray-600 rounded-md hover:bg-gray-500">
            Cancelar
          </button>
          <button onClick={handleSave} disabled={isSaving} className="px-6 py-2 font-bold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 disabled:opacity-50">
            {isSaving ? 'Guardando...' : 'Guardar Cambios'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DonationWidgetConfigModal;